module.exports = __webpack_public_path__ + "media/auto_main_information/pojazd_wycofany-0ac7133c.svg";